import { Box, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import RegulationsDialog from "../regulations/RegulationsDialog";
import { useQuery } from "@apollo/client";
import { PROFILE } from "@/graphql/queries/profile";
import useLessons from "@/components/course/lesson/hooks/useLessons";

export default function RegulationsMenu() {
    const [display, setDisplay] = useState(false);
    const [displayButton, setDisplayButton] = useState(false);

    const { getActiveLessonPreview } = useLessons({ courseId: 1 });
    const activeLessonPreview = getActiveLessonPreview();

    const { data: { profile } = {}, loading } = useQuery(PROFILE, {
        fetchPolicy: "cache-first",
    });

    const commited = profile?.commited ?? false;

    useEffect(() => {
        if (commited) {
            setDisplayButton(true);
        } else {
            if (
                activeLessonPreview?.lessonNumber > 5 ||
                (activeLessonPreview?.lessonNumber == 5 &&
                    activeLessonPreview?.lessonProrgress?.status ===
                        "COMPLETED")
            ) {
                setDisplayButton(true);
            }
        }
    }, [commited, activeLessonPreview]);

    return (
        <>
            <Box id="regulations-menu" sx={{ marginRight: "6px" }}>
                {displayButton && (
                    <IconButton
                        id="regulations-menu-button"
                        size="medium"
                        onClick={() => {
                            setDisplay(true);
                        }}
                    >
                        <DescriptionOutlinedIcon />
                    </IconButton>
                )}
            </Box>

            {display && <RegulationsDialog onClose={() => setDisplay(false)} />}
        </>
    );
}
